function load_cart() {
  fetch(window.Shopify.routes.root + '?section_id=cart-drawer')
    .then((response) => response.text())
    .then((responseText) => {
      const cartid = 'cart-drawer';
      const html = new DOMParser().parseFromString(responseText, 'text/html');
      const destination = document.querySelector('.cart-sidebar');
      const source = html.getElementById(cartid);
      if (source && destination) destination.innerHTML = source.innerHTML;
      document.querySelectorAll('.item-remove').forEach(function (cartRemove) {
        var data_line = cartRemove.dataset.line;
        cartRemove.addEventListener('click', (evt) => removeItem(data_line));
      });
      document.querySelectorAll('.quantity-minus').forEach(function (minus) {
        var data_line = minus.dataset.line;
        minus.addEventListener('click', function () {
          var currentQuantity = parseInt(document.getElementById(`Quantity-${data_line}`).value) - 1;
          document.getElementById(`Quantity-${data_line}`).value = currentQuantity;
          updateItem(data_line, currentQuantity);
        });
      });
      document.querySelectorAll('.quantity-plus').forEach(function (plus) {
        var data_line = plus.dataset.line;
        plus.addEventListener('click', function () {
          var currentQuantity = parseInt(document.getElementById(`Quantity-${data_line}`).value) + 1;
          document.getElementById(`Quantity-${data_line}`).value = currentQuantity;
          updateItem(data_line, currentQuantity);
        });
      });
      document.querySelectorAll('.header-cart').forEach(function (cartButton) {
        cartButton.addEventListener('click', function (e) {
          document.querySelector('body').classList.add('open-drawer');
          document.querySelector('body').classList.remove('open-menu', 'open-search', 'open-sort', 'open-filter');
        });
      });
      document.querySelectorAll('.overlay-box, .cart-drawer-close').forEach(function (cartButton) {
        cartButton.addEventListener('click', function (e) {
          document
            .querySelector('body')
            .classList.remove('open-drawer', 'open-menu', 'open-search', 'open-sort', 'open-filter', 'open-account-popup');
        });
      });

      
      empty_cart();
      productRecommended();
      accordian();
      $th_refreshWishlistItems();

      updateExpectedDate()

    });

}
load_cart();
function removeItem(data_line) {
  const data = { line: data_line, quantity: 0 };
  fetch('/cart/change.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((data) => {
      if (document.location.href.indexOf('/cart') > -1) {
        window.location.href = '/cart';
      } else {
        load_cart();
      }
    })
    .catch((error) => {
      console.error('Error:', error);
    });
}

function updateItem(data_line, quantity) {
  const data = { line: data_line, quantity: quantity };
  let error_grid = document.querySelector(`#Quantity-${data_line}`).closest('.item-row').querySelector('.grid-error');
  fetch('/cart/change.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((data) => {
      if (document.location.href.indexOf('/cart') > -1) {
        window.location.href = '/cart';
      } else {
        if(data.status == 422)
          {
              error_grid.innerHTML = data.description;
              setTimeout(function(e){
                    error_grid.innerHTML = '';
                    load_cart();

              },2000);
        }else{
          load_cart();
        }
      }
    })
    .catch((error) => {
      console.error('Error:', error);
    });
}



async function productRecommended() {
  const firstItem = document.querySelector('.item-row');
  if (!firstItem) return;

  const productId = firstItem.getAttribute('data-product-id');
  const container = document.getElementById('complementary-products-container');
  if (!container) return;

  const wrapper = container.querySelector('.swiper-wrapper');
  if (!wrapper) return;

  // wrapper.innerHTML = '<li class="swiper-slide loading">Loading Recommendations...</li>';
  const SECTION_ID = 'product-recommended-grid';

  try {
    const response = await fetch(`/recommendations/products.json?product_id=${productId}&recommendation_method=complementary&limit=4`);
    if (!response.ok) throw new Error(`HTTP ${response.status}`);

    const data = await response.json();
    const handles = (data.products || []).map(p => p.handle).filter(Boolean);

    if (handles.length === 0) {
      wrapper.innerHTML = '<li class="swiper-slide">No recommendations found.</li>';
      return;
    }

    const sections = await Promise.all(
      handles.map(async handle => {
        try {
          const r = await fetch(`/products/${handle}?sections=${SECTION_ID}`);
          const json = await r.json();
          return json[SECTION_ID];
        } catch (err) {
          console.error(`Failed to load ${handle}:`, err);
          return `<div class="error">Failed to load ${handle}</div>`;
        }
      })
    );

    wrapper.innerHTML = sections
      .map(sectionHTML => `<li class="swiper-slide">${sectionHTML}</li>`)
      .join('');

    // productrow();
    quickproductrow();
    quickAddButton();
    bindQuickViewButtons();
    // $th_refreshWishlistItems();
    // updateFLCprice();
    

    if (window.cartRecommendedSwiper) {
      window.cartRecommendedSwiper.destroy(true, true);
      window.cartRecommendedSwiper = null;
    }

    if (window.Swiper) {
      window.cartRecommendedSwiper = new Swiper('.cart-recommended-slider', {
        slidesPerView: 'auto',
        spaceBetween: 1,
        slidesOffsetAfter: 12,
        // pagination: {
        //   el: '.swiper-pagination',
        //   type: 'progressbar',
        // },
        scrollbar: {
          el: ".cart-recommended-slider .swiper-scrollbar",
          draggable: true,
        },
        grabCursor: true,
        on: {
          scrollbarDragStart() {
            document.body.classList.add('dragging');
          },
          scrollbarDragEnd() {
            document.body.classList.remove('dragging');
          }
        },
        breakpoints: {
          991:{ slidesOffsetAfter: 24 },
        },
      });

    }

  } catch (error) {
    console.error('Error fetching recommendations:', error);
    wrapper.innerHTML = '<li class="swiper-slide error">Error loading recommended products.</li>';
  }
}

function empty_cart(){
  window.cartRecommendedSwiper = new Swiper('.empty_cart-recommended-slider', {
    slidesPerView: 'auto',
    spaceBetween: 1,

    scrollbar: {
          el: ".empty_cart-recommended-slider .swiper-scrollbar",
          draggable: true,
        },
    grabCursor: true,
    on: {
      scrollbarDragStart() {
        document.body.classList.add('dragging');
      },
      scrollbarDragEnd() {
        document.body.classList.remove('dragging');
      }
    },
    slidesOffsetAfter: 12,
    breakpoints: {
      992: {
        slidesOffsetAfter: 24,
      },
    },
  });
  quickAddButton();
  quickproductrow();
  bindQuickViewButtons();
  // productrow();
  // updateFLCprice();
}



function updateExpectedDate() {
  const items = document.querySelectorAll('.drawer-middle .item-row');
  const firstWithEdDiv = Array.from(items).find(item => item.querySelector('.ed-div'));
  if (firstWithEdDiv) {
    const edDiv = firstWithEdDiv.querySelector('.ed-div');
    const text = edDiv.textContent.trim();
    const parts = text.split(':');
    const lastPart = parts[parts.length - 1].trim();
    const target = document.querySelector('.drawer-footer .expected-date.normal');
    if (target) {
      target.textContent = lastPart;
      target.style.filter = 'blur(0)';
      target.classList.add('remove-blur');
    }
  }
}
document.addEventListener('DOMContentLoaded', () => {
  setTimeout(updateExpectedDate, 1000);
});

document.addEventListener("DOMContentLoaded", function() {
  function initApplePayButtonCheck() {
    const applePayButton = document.querySelector(".cart-apple-pay-btn");
    if (!applePayButton) {
      setTimeout(initApplePayButtonCheck, 500);
      return;
    }
    const ua = navigator.userAgent;
    const isIOS = /iPhone|iPad|iPod/.test(ua);
    const isSafari = /Safari/.test(ua) && !/Chrome|CriOS|FxiOS|EdgiOS/.test(ua);
    if (!(isIOS && isSafari)) {
      applePayButton.style.display = "none";
    }
  }
  initApplePayButtonCheck();
});







    